import { Modal, message } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { DeleteReportModalStyles } from './styled';
import { EPButton } from '@/components';
import { useStores } from '@/hooks/use-stores';
import { useState } from 'react';
import { observer } from 'mobx-react';

interface DeleteReportModalProps {
  open: boolean;
  onClose: () => void;
  reportId: string | null;
  onSuccess?: () => void;
}

const DeleteReportModal = observer(
  ({ open, onClose, reportId, onSuccess }: DeleteReportModalProps) => {
    const { t } = useTranslation();
    const { reportStore } = useStores();
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDelete = async () => {
      if (!reportId) return;

      setIsDeleting(true);
      try {
        await reportStore.deleteReport(reportId);
        message.success(t('reportDeletedSuccessfully'));
        onClose();
        if (onSuccess) {
          onSuccess();
        }
      } catch (error) {
        message.error(t('failedToDeleteReport'));
      } finally {
        setIsDeleting(false);
      }
    };

    const handleCancel = () => {
      if (!isDeleting) {
        onClose();
      }
    };

    return (
      <Modal
        open={open}
        onCancel={handleCancel}
        footer={null}
        centered
        width={420}
        title={null}
        closable={!isDeleting}
        maskClosable={false}
      >
        <DeleteReportModalStyles>
          <div className="delete-report-modal-content">
            <div className="delete-report-icon">
              <ExclamationCircleOutlined />
            </div>
            <div className="delete-report-title">{t('deleteReport')}</div>
            <div className="delete-report-description">
              {t('areYouSureYouWantToDeleteThisReport')}
            </div>
            <div className="delete-report-actions">
              <EPButton onClick={handleCancel} disabled={isDeleting}>
                {t('Cancel')}
              </EPButton>
              <EPButton
                type="primary"
                onClick={handleDelete}
                loading={isDeleting}
              >
                {t('Yes')}
              </EPButton>
            </div>
          </div>
        </DeleteReportModalStyles>
      </Modal>
    );
  }
);

export default DeleteReportModal;

